import React from 'react'
import '../Styles/footer.css'

const footer = () => {
  return (
    <>
        <footer className="bg-dark text-center text-white">
            
            <div className="container p-4 pb-0">
                
                <section className="mb-4">
               
                    <a className="btn btn-outline-light btn-floating m-1" href="https://www.facebook.com/Miladetallesparaelhogar" role="button">                
                        <i className="fa-brands fa-facebook-square"></i>
                    </a>               
                    <a className="btn btn-outline-light btn-floating m-1" href="https://www.instagram.com/mila_detalles/" role="button">
                        <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a className="btn btn-outline-light btn-floating m-1" href="https://www.tiktok.com/@miladetalles" role="button">
                        <i className="fa-brands fa-tiktok"></i>
                    </a>
                </section>
              
            </div>
      
            <div className="text-center p-3" >
                © 2022 Copyright: Todos los derechos reservados. Diseñado y Programado por Macross y 
                <a className="text-white" href="https://miladetalles.com/"> miladetalles.com</a>
            </div>
         
            </footer>
    </>
  )
}

export default footer